import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import IntroPage from './IntroPage'
import OnboardingPage from './OnboardingPage' // New OnboardingPage component
import FormPage from './FormPage'
import ResultsPage from './ResultsPage'
import ScrollToTop from './ScrollToTop' 

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
          <Route path="/" element={<IntroPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/form" element={<FormPage />} />
          <Route path="/results" element={<ResultsPage />} />
      </Routes>
    </Router>
  )
}

export default App
